import React from 'react';
import { FileText, Download } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const CATALOG_TYPES = {
    catalog: { label: 'Catalogue', icon: FileText, color: 'bg-blue-100 text-blue-800' },
    flyer: { label: 'Flyer', icon: FileText, color: 'bg-green-100 text-green-800' },
    poster: { label: 'Affiche', icon: FileText, color: 'bg-purple-100 text-purple-800' },
};

const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
};

export const CatalogsTab = ({ catalogs, onDownload }) => {
    if (catalogs.length === 0) {
        return (
            <Card>
                <CardContent className="py-12 text-center">
                    <FileText className="h-16 w-16 text-muted-foreground mx-auto mb-4 opacity-50" />
                    <p className="text-muted-foreground">Aucun catalogue disponible pour le moment</p>
                </CardContent>
            </Card>
        );
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {catalogs.map((catalog) => (
                <Card key={catalog.id} className="hover:shadow-lg transition-shadow" data-testid={`catalog-card-${catalog.id}`}>
                    <CardHeader className="pb-3">
                        <div className="flex items-start justify-between">
                            <div className="flex items-center gap-3">
                                <div className={`p-3 rounded-xl ${CATALOG_TYPES[catalog.catalog_type]?.color || 'bg-gray-100'}`}>
                                    <FileText className="h-6 w-6" />
                                </div>
                                <div>
                                    <CardTitle className="text-lg">{catalog.title}</CardTitle>
                                    <Badge className={CATALOG_TYPES[catalog.catalog_type]?.color}>
                                        {CATALOG_TYPES[catalog.catalog_type]?.label || catalog.catalog_type}
                                    </Badge>
                                </div>
                            </div>
                        </div>
                    </CardHeader>
                    <CardContent>
                        {catalog.description && (
                            <p className="text-sm text-muted-foreground mb-4">{catalog.description}</p>
                        )}
                        <div className="flex items-center justify-between text-sm text-muted-foreground mb-4">
                            <span>{formatFileSize(catalog.file_size)}</span>
                            <span>{formatDate(catalog.created_at)}</span>
                        </div>
                        <Button
                            onClick={() => onDownload(catalog)}
                            className="w-full bg-jungle hover:bg-jungle/90"
                            data-testid={`download-catalog-${catalog.id}`}
                        >
                            <Download className="h-4 w-4 mr-2" />Télécharger
                        </Button>
                    </CardContent>
                </Card>
            ))}
        </div>
    );
};
